import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Products } from 'app/_models/products';
import { Observable, Subject } from 'rxjs';
import { UserModel } from 'app/_models/user-model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CrudProductService {
  currentUser: UserModel;
  _baseUrl = environment.baseUrl;
  constructor(private readonly http: HttpClient) { }
  private readonly _refreshrequired = new Subject<void>();

  get Refreshrequired() {
    return this._refreshrequired;
  }

  getProducts() {
    return this.http.get<Products[]>(this._baseUrl + 'Product/GetAllActiveProducts');
  }

  getAllActiveProducts() {
    return this.http.get<Products[]>(this._baseUrl + 'Product/GetAllActiveProducts');
  }

  deleteProduct(productId: string): Observable<any> {
    let model = {id:productId}
    return this.http.post<any>(this._baseUrl + 'Product/DeleteProduct', model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }

  updateProduct(model: Products): Observable<any> {
    return this.http.post<any>(this._baseUrl + 'Product/UpdateProduct', model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }

  saveProduct(productName: string, description: string): Observable<any> {
   
    let model = { productName: productName, description: description };
    let headers = new HttpHeaders({
      'x-api-version': '1.0'
        });
    let options = { headers: headers,  withCredentials: true  };
    return this.http.post<any>(this._baseUrl + 'Product/AddProduct', model, options).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }

}
